export class Token {
    token: string;
    refresh_token: string;
    user: any;
    base_path?: any;
}